import { useDispatch, useSelector } from 'react-redux'; 
import { fetchNews } from "../../store/reducers/news.js";
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Box, Typography, LinearProgress, Stack } from "@mui/material"; 
import { CardNews } from "../../components/cardNews/CardNews.jsx"
import NewsPagination from '../filterNews/newsPagination/NewsPagination.jsx';
import dayjs from 'dayjs';
import { baseUrlApi } from '../constants.js';

export function CatalogNews() {
    const dispatch = useDispatch();
    const { news } = useSelector((state) => state.news);
    const isLoadingNews = news.status === 'loading';
    const { data } = useSelector((state) => state.auth);
    const typeNewsStore  = useSelector(state => state.valueFiltersNews.type);
    const yearInterval = useSelector(state => state.valueFiltersNews.yearRange);
    const inputName = useSelector(state => state.valueFiltersNews.nameNews);

    const PAGE_NUM_DEFAULT = 1; 
    const PAGE_COUNT_DEFAULT = 1; 
    const COUNT_NEWS_ON_PAGE = 5; 
    const [pageNum, setPageNum] = useState(PAGE_NUM_DEFAULT); 
    const [pageCount, setPageCount] = useState(PAGE_COUNT_DEFAULT);

    const COUNT_TYPES_NEWS = 9;

    useEffect(() => {
        dispatch(fetchNews())
    }, [])

    let catalogNewsFilterWithPagination;
    let catalogNewsListFilter;
    
    useEffect(() => {
        catalogNewsListFilter && setPageCount(Math.ceil(catalogNewsListFilter.length/COUNT_NEWS_ON_PAGE));
        setPageNum(PAGE_NUM_DEFAULT);
    }, [typeNewsStore, yearInterval, inputName, news])

    if(!isLoadingNews){
        catalogNewsListFilter = news.items.filter((element) => {
            let includedInRange = false; 
            const dateNewsFormatString = dayjs(element.dateNewsFormat).format('DD.MM.YYYY');
            if(dateNewsFormatString.length > 0){
                const yearString = dateNewsFormatString.substring(dateNewsFormatString.length - 4);
                const yearNumber = parseInt(yearString);
                includedInRange = ((yearNumber >= yearInterval.min) && (yearNumber <= yearInterval.max));
            } 
            
            const includedSearchName = element.title.toLowerCase().includes(inputName.toLowerCase());
            
            let includedType = true;
            if(typeNewsStore.length < COUNT_TYPES_NEWS) {
                for (let i = 0; i < element.typesProgramStore.length; i++) {
                    includedType = typeNewsStore.some(item => item === element.typesProgramStore[i]);
                    if (includedType){
                        break;
                    }
                }
            } else {
                includedType = true; 
            }   
            
            if (includedInRange && includedSearchName && includedType){ 
                return element;
            }
        });
        
        console.log("Количество страниц ", pageCount);
        catalogNewsFilterWithPagination = catalogNewsListFilter.slice((COUNT_NEWS_ON_PAGE*pageNum)-COUNT_NEWS_ON_PAGE, (COUNT_NEWS_ON_PAGE*pageNum)); 
    }
    
    return(
        <>
            <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "start",
                alignContent: "flex-start",
                pl: "37rem",
                "@media(max-width: 50rem)": {
                    p: "0rem",
                    ml: "1rem", 
                },
            }}
            >
                <Grid container spacing={4}>
                    <Grid xs={11} md={9} item> 
                    
                    {isLoadingNews ? (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100vh',
                                width: '100%',
                            }}
                        >
                            <Stack sx={{ width: '70%', color: 'grey.500' }} spacing={2}>
                                <LinearProgress />
                            </Stack>
                        </Box>
                    ) : (
                        <>
                            {catalogNewsFilterWithPagination && catalogNewsFilterWithPagination.length > 0 ? (
                                catalogNewsFilterWithPagination.map((obj, index) => (
                                    <CardNews
                                        key={obj._id}
                                        id={obj._id}
                                        title={obj.title}
                                        imageUrl={obj.imageUrl}
                                        imagesUrls={obj.imagesUrls || []} // ← ВАЖНО: передаем массив изображений
                                        isEditable={data !== undefined && data !== null}
                                        textNews={obj.text}
                                        typesProgramStore={obj.typesProgramStore}
                                        programName={obj.programName}
                                        dateNewsFormat={obj.dateNewsFormat}
                                        linkProgramm={obj.linkProgramm}
                                        linkNews={obj.linkNews}
                                    />
                                ))
                            ) : (
                                <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100vh',
                                    width: '100%',
                                    color: "grey",
                                    fontSize: "1.15rem",
                                }}
                                >
                                    <Typography variant="body1">Новостей по данным параметрам не найдено</Typography>
                                </Box>
                            )}
                        </>
                    )}
                    <NewsPagination 
                        pageCount={pageCount}
                        setPageNum={setPageNum}
                    />
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}